
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Ω / Icons / platforms / windows","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 28 28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28 28l-15.166-2.107V15.167H28V28zm-16.333-2.332L0 24.087v-8.92h11.667v10.5zM28 14H12.834V2.108L28 0v14zm-16.333 0H0V3.913l11.667-1.581V14z","fill":"#011936"}})])
          )
        }
      }
    